module.exports = __webpack_public_path__ + "img/shequ-6.85e5d2ba.png";